
<template>
    <footer class="footer">
      <!-- First row -->
      <div class="footer-top">
        <!-- Column 1: Echo logo and developer name -->
        <div class="footer-column">
          <img
            class="footer-logo"
            src="https://firebasestorage.googleapis.com/v0/b/producer-feedback.firebasestorage.app/o/BASE%2Fecho-logo_v2.svg?alt=media&token=51106614-9e53-474c-832f-bf7e195e0439"
            alt="Echo Logo"
          />
          <div class="dev-by">
          <p>Developed by Jack C Ward 🫶</p>
          </div>
        </div>
  
        <!-- Column 2: Explore -->
        <div class="footer-column">
          <h3>Explore</h3>
          <ul>
            <li><router-link to="/projectlist">Projects</router-link></li>
            <li><router-link to="/profile">Profile</router-link></li>
          </ul>
        </div>
  
        <!-- Column 3: Resources -->
        <div class="footer-column">
          <h3>Resources</h3>
          <ul>
            <li><router-link to="/help">Help</router-link></li>
            <li><router-link to="/tickets">Bug report</router-link></li>
            <li><router-link to="/dev">Blog</router-link></li>
          </ul>
        </div>
  
        <!-- Column 4: Admin tools (visible only if isAdmin is true) -->
        <div class="footer-column" v-if="isAdmin">
          <h3>Admin tools</h3>
          <ul>
            <li><router-link to="/members">Member management</router-link></li>
            <li><router-link to="/knowledge-editor">Help editor</router-link></li>
          </ul>
        </div>
      </div>
  
      <!-- Second row: Center aligned text -->
      <div class="footer-bottom">
        <p>&amp;tools Echo by &amp;NatWest Production Team - v0.8.1704a</p>
      </div>
    </footer>
  </template>
  
  <script>
  export default {
    name: "SiteFooter",
    props: {
      // This prop controls the visibility of the admin tools column
      isAdmin: {
        type: Boolean,
        default: false,
      },
    },
  };
  </script>
  
  <style scoped>
  .footer {
    padding: 8rem 1rem 1rem 1rem;
    max-width: 1000px;
    margin: 0 auto;
  }
  
  .footer-top {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    border-top: 1px solid #ddd;
    padding-top: 1rem;
  }
  
  .footer-column {
    flex: 1;
    margin: 0.5rem;
  }
  
  .footer-column h3 {
    margin-bottom: -0.5rem;
    color: #595959;
  }
  
  .footer-column ul {
    list-style: none;
    padding: 0;
  }
  
  .footer-column ul li {
    margin-bottom: 0.25rem;
  }
  
  .footer-logo {
    max-width: 100px;
    height: auto;
    margin-bottom: 0rem;
  }
  
  .footer-bottom {
    text-align: center;
    margin-top: 1rem;
    font-size: 0.8rem;
    color: #cacaca;
  }

  .footer-column a {
  color: #cacaca;            
  text-decoration: none;  
  transition: color 0.3s;
  font-size: 0.9rem;
}

.footer-column a:hover {
  color: #EA845A;
}

.footer-column a:active {
  color: #EA845A;
}

  .dev-by {
    font-size: 0.6rem;
    color: #EA845A;
    margin-top: -1rem;
    transition: 0.5s;
  }

  .dev-by:hover {
    color: #EA845A;
    text-shadow: 4px 2px 6px #FFB681;
    font-size: 0.65rem;
  }
  </style>
  